import { createSelector } from 'reselect';

import { RootState } from '@/app/store';
import { selectUser } from '@/entities/user';

export const selectJettonRound = (s: RootState) => s.jetton.currentRound;
export const selectJettonStatus = (s: RootState) => s.jetton.currentRound.status;
export const selectJettonBets = (s: RootState) => s.jetton.currentRound.bets;
export const selectJettonTotalBet = (s: RootState) => s.jetton.currentRound.totalBet;
export const selectJettonStartTimeMs = (s: RootState) => s.jetton.currentRound.startTimeMs;
export const selectWaitingEndsAtMs = (s: RootState) => s.jetton.waitingEndsAtMs;
export const selectJettonCrashMultiplier = (s: RootState) => s.jetton.currentRound.crashMultiplier;
export const selectJettonHistory = (s: RootState) => s.jetton.history;
export const selectJettonServerSeedHash = (s: RootState) => s.jetton.currentRound.serverSeedHash;
export const selectJettonIndex = (s: RootState) => s.jetton.currentRound.index;
export const selectJettonSelectedCurrency = (s: RootState) => s.jetton.selectedCurrency;
export const selectMyCashout = createSelector(
  (s: RootState) => s.jetton.myCashout,
  (myCashout) => myCashout,
);

export const selectMultiplierState = createSelector(
  [selectJettonStatus, selectJettonStartTimeMs, selectJettonCrashMultiplier],
  (status, startTimeMs, crashMultiplier) => ({ status, startTimeMs, crashMultiplier }),
);

export const selectMyBet = createSelector(
  [selectJettonBets, selectUser],
  (bets, user) => (user ? (bets.find((b) => b.userId === user.id) ?? null) : null),
);

export const selectAutoplay = (s: RootState) => s.jetton.autoplay;
export const selectIsAutoplayActive = (s: RootState) => s.jetton.autoplay.isActive;

export const selectBetPanelState = createSelector(
  [
    selectJettonStatus,
    selectMyBet,
    selectWaitingEndsAtMs,
    selectMyCashout,
    selectJettonSelectedCurrency,
    (s: RootState) => s.user.data?.wallets?.[s.jetton.selectedCurrency]?.balance ?? 0,
    selectAutoplay,
  ],
  (status, myBet, waitingEndsAtMs, myCashout, selectedCurrency, balance, autoplay) => ({
    status,
    myBet,
    waitingEndsAtMs,
    myCashout,
    selectedCurrency,
    balance,
    autoplay,
  }),
);
